module.exports = __webpack_public_path__ + "img/card-therapyrooms-hipaa.1afa6386.svg";